var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.viewModeClass },
    [
      _vm.viewMethod == "default"
        ? [
            _c(
              "span",
              { staticClass: "icon", class: { loggedin: _vm.isLoggedIn } },
              [
                !_vm.isLoggedIn
                  ? _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          href: _vm.isLogin ? "javascript:void(0)" : "#login",
                          "data-toggle": _vm.isLogin ? false : "modal",
                          "aria-label": _vm.$translate("Ceres::Template.login"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.createLoginModal()
                            _vm.createRegisterModal()
                            _vm.unmarkInputFields()
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-width": "2",
                              "stroke-linecap": "butt",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                              },
                            }),
                            _c("circle", {
                              attrs: { cx: "12", cy: "7", r: "4" },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "#000000",
                            "stroke-width": "2",
                            "stroke-linecap": "butt",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                            },
                          }),
                          _c("circle", {
                            attrs: { cx: "12", cy: "7", r: "4" },
                          }),
                        ]
                      ),
                    ]),
              ]
            ),
          ]
        : _vm.viewMethod == "mobile"
        ? [
            !_vm.isLoggedIn
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                    },
                    on: {
                      click: function ($event) {
                        _vm.createLoginModal()
                        _vm.createRegisterModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-user",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                          },
                        }),
                        _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "mini",
                      attrs: { nologin: "" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$translate("Ceres::Template.login")
                        ),
                      },
                    }),
                  ]
                )
              : _c(
                  "a",
                  {
                    staticClass: "loggedin",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-user",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                          },
                        }),
                        _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "mini",
                      attrs: { loggedin: "" },
                      domProps: { innerHTML: _vm._s("Mein Konto") },
                    }),
                  ]
                ),
          ]
        : _vm.viewMethod == "wishlist"
        ? [
            _c("span", { staticClass: "icon" }, [
              _c("i", {
                attrs: { "data-feather": "heart", "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                  },
                  on: {
                    click: function ($event) {
                      _vm.createLoginModal()
                      _vm.createRegisterModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [_vm._v("Anmelden")]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }